module.exports = __webpack_public_path__ + "static/prepaidFeature2-037df4e9af835dc61f7986823d06b86f.svg";